import { ReportSendEmailUpdateModel, ReportPrintTemplateUpdateModel } from "../models/report";
import store, { storeModules, IRootState } from "../store";
import { SendMessageModule } from "../store/report/report-send-message";
import { LargeMailingModule } from "../store/report/report-large-mailing";
import sendMessageDefineTypesStore from "../store/report/report-send-message/define-types.store";
import largeMailingDefineTypesStore from "../store/report/report-large-mailing/define-types.store";

import { PrintTemplateModule } from "../store/report/report-print-template";
import printTemplateDefineTypesStore from "../store/report/report-print-template/define-types.store";

const updateArrayFieldMutation = (updateModel) => {
    store.commit(storeModules.ReportSendMessage + '/' + sendMessageDefineTypesStore.Set.UPDATE_iTEM_ARRAY_FIELD_SENDEMAIL, updateModel)
}
const updateArrayFieldEmail = (fieldName: string, value: any) => {
    let updateModel = new ReportSendEmailUpdateModel();
    updateModel.Field = fieldName;
    updateModel.Value = value;
    
    updateArrayFieldMutation(updateModel);
}

const updateLMArrayFieldMutation = (updateModel) => {
    store.commit(storeModules.ReportLargeMailing + '/' + largeMailingDefineTypesStore.Set.UPDATE_iTEM_ARRAY_FIELD_LARGEMAILING, updateModel)
}
const updateLMArrayFieldEmail = (fieldName: string, value: any) => {
    let updateModel = new ReportSendEmailUpdateModel();
    updateModel.Field = fieldName;
    updateModel.Value = value;
    
    updateLMArrayFieldMutation(updateModel);
}

const getReportTempleteObject = (fieldName: string, value: any) => {
    let updateModel = new ReportPrintTemplateUpdateModel();
    updateModel.Field = fieldName;
    updateModel.Value = value;
    return updateModel
}
interface SendEmailParamModel {
    Module: number;
    PropertyIds?: number[];
    PersonIds?: number[];
    DemandIds?: number[];
    TaskIds?: number[];
    IsMailling?: boolean;
    IsOwner?: boolean;
    IsActualTenant?: boolean;
    AppointmentIds?: number[];
    PropertyDisabled?: boolean;
    PersonDisabled?: boolean;
    Emails?: string[];
    IsSelectAll?: boolean;
    PropertyCondition?: any;
    PersonCondition?: any;
    DemandCondtion?: any;
    PropertyTaskIds?: any[];
    TaskCondtion?: any;
    IsOwnerMailing?: boolean;
    PaymentRequestId?: number;
    MatchingDemandRequest?: {
        Condition: any,
        IsMatchingDemandSendEmail: boolean,
        PropertyId: number,
        PageIndex:number,
        PageSize: number
    }
    MatchingPropertyRequest?: {
        Condition: any,
        IsMatchingPropertySendEmail: boolean,
        DemandId: number,
        PageIndex: number,
        PageSize: number
    }
}

interface LargeMailingParamModel {
    Module: number;
    PropertyIds?: number[];
    PersonIds?: number[];
    DemandIds?: number[];
    IsMailling?: boolean;
    IsOwner?: boolean;
    IsActualTenant?: boolean;
    AppointmentIds?: number[];
    PropertyDisabled?: boolean;
    PersonInfos?: any[];
    DemandInfos?: any[];
    IsSelectAll?: boolean;
    PersonCondition?: any;
    DemandCondtion?: any;
}

interface PrintTemplateParamModel {
    moduleTemplate: string,
    dataFields: Array<ItemField>,
    templateLookupValue: TemplateValue,
    lookupTemplateAction: TemplateAction
}

interface ItemField {
    key: string,
    value: any
}

interface TemplateValue {
    Type: string,
    SelectedIds: Array<number>
}

interface TemplateAction {
    actionType: string,
    data: any
}
export class ReportHelper {
    static initSendEmailModal = (params: SendEmailParamModel) => {
        const sendMessageModule = new SendMessageModule<IRootState>()
        if (!store.state[storeModules.ReportSendMessage]) {
            store.registerModule(storeModules.ReportSendMessage, sendMessageModule);
        }
        store.commit(storeModules.ReportSendMessage + '/' + sendMessageDefineTypesStore.Set.INIT_SENDEMAIL, params.Module);
        Object.keys(params).forEach(key => {
            updateArrayFieldEmail(key, params[key]);
        })
    }

    static initPrintTemplateModal = (params: PrintTemplateParamModel) => {
        // register ReportPrintTemplate to store vuex
       if(!store.state[storeModules.ReportPrintTemplate]) {
           store.registerModule(storeModules.ReportPrintTemplate, new PrintTemplateModule<IRootState>());
       }
       const typePrefix = storeModules.ReportPrintTemplate + '/';
      
       // commit init ptint template {value}
       store.commit(typePrefix + printTemplateDefineTypesStore.Set.INIT_PRINTTEMPLATE, params.moduleTemplate);
       
       // commit set data for templete {field: value}
       const dataFields = params.dataFields || [];
       dataFields.forEach(item => {
           const reportObject = getReportTempleteObject(item.key, item.value)
           store.commit(typePrefix + printTemplateDefineTypesStore.Set.UPDATE_iTEM_ARRAY_FIELD_PRINTTEMPLATE, reportObject)
       });
       // dispatch loadTemplatesLookupsForPrintTemplate {value}
        store.dispatch(typePrefix + printTemplateDefineTypesStore.Get.GET_LOOKUP_TEMPLATES, params.templateLookupValue)
   
       // dispatch load { Demand || Person || Property } LookupsForPrintTemplate {value}
       store.dispatch(typePrefix + params.lookupTemplateAction.actionType, params.lookupTemplateAction.data)
   }

    static iniLargeMailingModal = (params: LargeMailingParamModel) => {
        const sendLargeMailingModule = new LargeMailingModule<IRootState>()
        if (!store.state[storeModules.ReportLargeMailing]) {
            store.registerModule(storeModules.ReportLargeMailing, sendLargeMailingModule);
        }
        store.commit(storeModules.ReportLargeMailing + '/' + largeMailingDefineTypesStore.Set.INIT_LARGEMAILING, params.Module);
        Object.keys(params).forEach(key => {
            updateLMArrayFieldEmail(key, params[key]);
        })
    }
}
